import wx from 'weixin-js-sdk'

function getJSSDK (data, params) {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: 'wxefa630292d5b057e', // 必填，公众号的唯一标识
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.nonceStr, // 必填，生成签名的随机串
    signature: data.signature, // 必填，签名
    jsApiList: [ // 必填，需要使用的JS接口列表
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
      'onMenuShareQQ',
      'onMenuShareQZone',
      'onMenuShareWeibo'],
    success: () => {
      // alert('success')
    },
  })
  wx.ready(function () {
    // share to friend
    wx.onMenuShareAppMessage({
      title: params.title,
      // desc: params.desc,
      link: params.linkurl,
      imgUrl: params.img,
      success: function (res) {
        console('已分享给朋友');
      },
      cancel: function (res) {
        console('已取消');
      },
      fail: function (err) {
        console('分享给朋友fail: ', err);
      }
    });
    // 分享到朋友圈
    wx.onMenuShareTimeline({
      title: params.title,
      link: params.linkurl,
      imgUrl: params.img,
      success: function (res) {
        console('已分享到朋友圈');
      },
      cancel: function (res) {
        console('已取消');
      },
      fail: function (err) {
        console('分享到朋友圈fail: ', err);
      }
    });
    // 分享到QQ
    wx.onMenuShareQQ({
      title: params.title,
      link: params.linkurl,
      imgUrl: params.img,
      success: function (res) {
        console('已分享到QQ');
      },
      cancel: function (res) {
        console('已取消');
      },
      fail: function (err) {
        console('分享到QQ fail: ', err);
      }
    });
    // 分享到QQ空间
    wx.onMenuShareQZone({
      title: params.title,
      link: params.linkurl,
      imgUrl: params.img,
      success: function (res) {
        console('已分享到QQ空间');
      },
      cancel: function (res) {
        console('已取消');
      },
      fail: function (err) {
        console('分享到QQ空间fail: ', err);
      }
    });
    // 获取“分享到腾讯微博”按钮点击、自定义分享内容及分享结果接口
    wx.onMenuShareWeibo({
      title: params.title,
      // desc: params.desc,
      link: params.linkurl,
      imgUrl: params.img,
      complete: function (res) {
        // alert(JSON.stringify(res));
      },
      success: function (res) {
        console('已分享到腾讯微博');
      },
      cancel: function (res) {
        console('已取消');
      },
      fail: function (err) {
        console('分享到腾讯微博fail: ', err);
      }
    });
  })
  wx.error((res) => {
    console.log(JSON.stringify(res) + "微信验证失败");
  });
}
export {
  getJSSDK
}